import { FunctionalComponent, h } from '@stencil/core';

interface NestDatePickerHeaderProps {
  actions?: Array<{
    label: string,
    handler?: () => void;
    disabled?: boolean;
  }>
  nextHandler?: () => void;
  prevHandler?: () => void;
  disabled?: {
    next?: boolean;
    prev?: boolean;
  }
}

export const NestDatePickerHeader: FunctionalComponent<NestDatePickerHeaderProps> = ({
  actions,
  nextHandler,
  prevHandler,
  disabled
}) => (
  <div class="grid grid-cols-5 items-center gap-x-3 mx-1.5 pb-3">
    <div class="col-span-1">
      <button
        disabled={disabled.prev}
        onClick={prevHandler}
        type="button"
        class="size-8 flex justify-center items-center text-foreground hover:text-background/50 rounded-full disabled:cursor-default disabled:opacity-50 disabled:pointer-events-none">
        <nest-icon name='chevron-left' class='w-5 h-5'/>
      </button>
    </div>

    <div class="col-span-3 flex justify-center items-center gap-x-1">
      {actions.map(action => (
        <div class="relative">
          <div class="hs-select relative">
            <button
              disabled={action.disabled}
              onClick={action.handler}
              type="button"
              class="disabled:cursor-default disabled:opacity-50 relative flex text-nowrap w-full text-start font-medium text-foreground hover:text-blue-600 disabled:hover:text-gray-50 focus:outline-none focus:text-gray-600 before:absolute before:inset-0 before:z-[1]"
            >
              <span class="truncate">{action.label}</span>
            </button>
          </div>
        </div>
      ))}
    </div>

    <div class="col-span-1 flex justify-end">
      <button
        disabled={disabled.next}
        onClick={nextHandler}
        type="button"
        class="size-8 flex justify-center items-center text-foreground hover:bg-gray-100 rounded-full disabled:cursor-default disabled:opacity-50 disabled:pointer-events-none">
        <nest-icon name='chevron-right' class='w-5 h-5'/>
      </button>
    </div>
  </div>
);
